import React, { useEffect } from 'react';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import { Box, IconButton, InputBase, Paper } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import BuzzPagination from '../../../components/BuzzPagination/BuzzPagination';
import { generatedLeadsColumn } from './columns';
import SearchIcon from '@material-ui/icons/Search';
import { getGeneratedLeadsAsync } from './GeneratedStore/generatedStoreSlice';

const GeneratedLeads = () => {
  const [page, setPage] = React.useState(1);
  const [couponCode, setCouponCode] = React.useState('');
  const dispatch = useDispatch();
  const { affiliateGetLeads, moduleAccess } = useSelector(
    ({ GeneratedReducer, signInReducer }) => {
      return {
        affiliateGetLeads:
          GeneratedReducer.reffercodes && GeneratedReducer.reffercodes.data,
        moduleAccess: signInReducer.me
          ? signInReducer.me.data
            ? signInReducer.me.data.role
            : []
          : [],
      };
    }
  );

  React.useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      dispatch(
        getGeneratedLeadsAsync({
          params: {
            name: '',
          },
        })
      )
        .unwrap()
        .then(() => {
          toast.success('All Leads have been fetched.');
        });
    } catch (error) {
      toast.error('Leads could not be fetched, please try after some time.');
    }
  };

  const handleSearchUser = () => {
    // API call
    dispatch(
      getGeneratedLeadsAsync({
        params: {
          code: couponCode,
        },
      })
    )
      .unwrap()
      .then((res) => {
        // toast.success('All Offer Details fetched successfully.');
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  useEffect(() => {
    handleSearchUser();
  }, [couponCode]);

  const handlePageChange = (val) => {
    if (val !== page) {
      setPage(val);
      dispatch(
        getGeneratedLeadsAsync({
          params: { page: val, limit: 10 },
        })
      )
        .unwrap()
        .then(() => {
          toast.success('All Leads were fetched successfully!');
        })
        .catch((err) => {
          toast.error(err.message);
        });
    }
  };

  return (
    <Box>
      <Box maxWidth={350} mb={2}>
        <Paper component="form">
          <InputBase
            placeholder="Search by Coupon Code"
            inputProps={{ 'aria-label': 'Search by Coupon Code' }}
            style={{ width: '300px', paddingLeft: '10px' }}
            onChange={(e) => setCouponCode(e.target.value.trim())}
          />
          <IconButton
            onClick={handleSearchUser}
            type="button"
            aria-label="search">
            <SearchIcon />
          </IconButton>
        </Paper>
      </Box>
      <Box mb={4}>
        <BuzzTable
          columns={generatedLeadsColumn}
          data={
            moduleAccess.includes('bccSuperAdmin')
              ? affiliateGetLeads && affiliateGetLeads.users
              : affiliateGetLeads &&
                affiliateGetLeads.users.filter(
                  (u) => u.refferCode === couponCode
                )
          }
        />
        <Box display="flex" justifyContent="center" pb={3}>
          <BuzzPagination
            onClick={handlePageChange}
            total={affiliateGetLeads && affiliateGetLeads.count}
            pageNo={page}
            defaultPage={1}
            perPage={10}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default GeneratedLeads;
